import ModuleBase from "#/common/ModuleBase";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";

type DateConfig = {
  minDate?: string;
  maxDate?: string;
};

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class TypeConfigurationContextSelectionModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  public mounted() {
    const url = window.location.pathname;
    const array = url.split("/");
    this.selectedCountry = array[2];
    this.value = new Date().toISOString();

    this.initialize().then(async () => {
      if(this.$store.typeSelectionFilter.configSelection?.showConfigSelection) {
        this.value = this.$store.typeSelectionFilter.filter.get("deliveryDate")

        await this.$store.typeSelectionFilter.setConfigValue("country", this.selectedCountry, false);
        this.$eventBus.$emit("cms.vehicleconfigs.refresh");

        this.dateConfig = {
          minDate: this.$store.typeSelectionFilter.configSelection?.dates?.min,
          maxDate: this.$store.typeSelectionFilter.configSelection?.dates?.max,
        };
      }
    });
  }

  public dateConfig: DateConfig = {
    minDate: undefined,
    maxDate: undefined,
  };

  public value: string = "";

  public selectedCountry: string = "DE";

  private async initialize() {
    this.$store.typeSelectionFilter.hasConfigSelection = true;
    await this.$store.typeSelectionFilter.loadFilterSession();
    await this.$store.typeSelectionFilter.loadConfigSelection();
  }

  get showSelection() {
    return !this.instance["hide_selection"];
  }

  get countries() {
    return this.$store.page.headerRegions.slice()[0].laender.slice();
  }

  async onCountrySelect(country: string) {
    const url = window.location.pathname;
    let array = url.split("/");

    if (country) {
      array[2] = country;
    } else {
      array[2] = "DE";
    }
    array.push(window.location.search);

    window.location.href = array.join("/");
  }

  async onInputDeliveryDate(date: string) {
    this.$store.typeSelectionFilter.setConfigValue("deliveryDate", date, true).then(() => {
      this.$eventBus.$emit("cms.vehicleconfigs.refresh");
    });
  }
}
